/* 网络收益详情 */
<template>
  <div class="home net-detail-home">
    <Layout type="REVENUE" isRevenue="true" :pageTitle="$t('menu.revenueDetails')">
      <BasiceLayout :title=" $t('menu.netRevenueDetails') " class="revenue-layout">
        <div class="revenue-detail-select">
          <div v-if="network_bxc" class="detail-total-revenue margin-20">{{$t('tolal_revenue')}}: &nbsp; &nbsp; {{network_bxc.toFixed(6)}}</div>
          <span class="revenue-date-wrap">{{$t('revenueDate')}}:</span>
          <el-select v-model="selectDate" filterable @change="search">
            <el-option v-for="item in queryDate" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          <span class="search-text">{{$t('search_mac_address')}}</span>
          <!-- <el-select v-model="searchMacAddress" filterable placeholder="" @change="searchMac">
            <el-option v-for="item in allDevices" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
          <el-input class="search-mac-input" v-model="searchMacAddress" placeholder="" @change="searchMac"></el-input>
        </div>
        <el-table v-if="detailList !== 'NO_CONTENT'" :data="detailList" align="left" empty-text="-" style="width: 100%">
          <!-- mac address -->
          <el-table-column prop="mac_address" align='center' :label="$t('mac_address')">
          </el-table-column>
          <!-- 备注 -->
          <el-table-column :label="$t('noteText')" align='center'>
            <template slot-scope="scope">
              <div v-if="scope.row.note">{{scope.row.note}}</div>
              <div v-if="!scope.row.note" :deviceId="scope.row.deviceId"
                @click="showNotes(scope.row.id, scope.row.mac_address)" class="add-note-button button bonus-cursor">
                {{$t('addNote')}}</div>
              <i v-if="scope.row.note && scope.row.noteStatus" class="el-icon-edit"  @click="showNotes(scope.row.id, scope.row.mac_address)"></i>
            </template>
          </el-table-column>
          <!-- 监测 -->
          <el-table-column prop="" :label="$t('watch')" align='center'>
            <template slot-scope="scope">
              <img class="watch-icon" @click="showWatchDetail('id', scope.row.id)" src="../../../assets/hardList/watch.png">
            </template>
          </el-table-column>
          <!-- 设备收益 -->
          <el-table-column prop="revenue" align='center' :label="$t('device_revenue')"></el-table-column>
          <!-- 历史收益 -->
          <el-table-column
            align='center'
            label="历史收益"
          >
            <template slot-scope="scope">
              <img
                class="watch-icon"
                @click="showDeviceRevenue(scope.row.id)"
                src="../../../assets/revenueBlack.png"
              >
            </template>
          </el-table-column>
        </el-table>
        <el-table v-if="detailList === 'NO_CONTENT'" :data="detailList" align="left" empty-text="system upgrade.."
          style="width: 100%">
        </el-table>
        <div class="pagination" v-if="deviceNumSize > 1">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
            :page-size="deviceNumSize" layout="total, prev, pager, next" :total="deviceLength">
          </el-pagination>
        </div>
        <!-- 增加备注 -->
        <el-dialog :title="$t('addNotes.title')" :visible.sync="showAddnoteDialog" width="480px" center>
          <div class="addnote-dialog-wrap">
            <span class="key">{{$t('addNotes.tipText')}}({{addNoteAddress}})</span>
            <input type="text" class="basic-input input addnote-input" v-model="addNoteInput">
          </div>
          <span slot="footer" class="dialog-footer">
            <div class="sure-unbind button" @click="showAddnoteDialog = false">{{ $t('cancel') }}</div>
            <div class="sure-unbind button" type="primary" @click="addNote">{{ $t('confirm') }}</div>
          </span>
        </el-dialog>
        <!-- 监控 -->
        <el-dialog :title="$t('watchDetail.title')" :visible.sync="showWatchDialog" width="60%" center>
          <div class="watch-dialog-wrap">
            <span class="key"></span>
            <div class="watch-select">
              <span class="search-text">{{$t('watchDetail.watchDate')}}:</span>
              <el-select v-model="searchWatchDate" filterable placeholder="" @change="showWatchDetail">
                <el-option v-for="item in queryDate" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
            <div v-if="showCharts">
              <ve-line class="watch-chart" :data="stableCharts"></ve-line>
              <ve-line class="watch-chart" :data="availabilityChart"></ve-line>
            </div>
          </div>
          <div v-if="!showCharts" class="no-watch-data">{{$t('watchDetail.noData')}}</div>
        </el-dialog>
      </BasiceLayout>
    </Layout>
    <!-- 历史收益 -->
    <el-dialog
      title="历史收益"
      :visible.sync="showLastRevenueDialog"
      width="70%"
      center
    >
      <div class="addnote-dialog-wrap">
        <LineCharts :chartData="chartData"></LineCharts>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          type="primary"
          @click="showLastRevenueDialog = false"
        >{{ $t('confirm') }}</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Header from "@/components/Header.vue";
  import Layout from "@/components/DatePanel/Layout.vue";
  import RevenueContent from "@/components/RevenueDetail/RevenueContent.vue";
  import BasiceLayout from "@/components/Common/BasicLayout.vue";
  import moment from "moment";
  import { mapActions, mapState } from "vuex";
  import { Message } from "element-ui";
  import LineCharts from "@/components/Common/LineCharts.vue";
  const type = "network";

  export default {
    name: "home",
    data() {
      return {
        selectDate: moment()
          .utc()
          .startOf("day")
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
        pageNum: 1,
        addNoteInput: "",
        addNoteAddress: "", //添加备注Id
        showAddnoteDialog: false,
        searchMacAddress: "",
        showWatchDialog: false, //监控弹框
        searchWatchDate: moment()
          .utc()
          .startOf("day")
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
        stableCharts: {},
        availabilityChart: {},
        showCharts: 'waiting',
        showLastRevenueDialog: false,
        chartData: {}
      };
    },
    components: {
      Header,
      Layout,
      BasiceLayout,
      LineCharts
    },
    computed: mapState({
      //  箭头函数可使代码更简练
      deviceLength: state => state.revenueDetail.deviceLength,
      currentPage: state => state.revenueDetail.currentPage,
      deviceNumSize: state => state.revenueDetail.deviceNumSize,
      detailList: state => state.revenueDetail.detailList,
      allDevices: state => state.revenueDetail.allDevices,
      network_bxc: state => state.revenueDetail.network_bxc,
      queryDate: () => {
        let queryDate = [];
        let endDay = moment()
          .utc()
          .startOf("day");

        endDay -= 24 * 60 * 60 * 1000;
        let i = 0;
        while (i < 7) {
          i++;
          queryDate.push(moment(endDay).format("YYYY-MM-DD"));
          endDay -= 24 * 60 * 60 * 1000;
        }

        return queryDate;
      }
    }),
    created() {
      let queryDate = moment()
        .utc()
        .startOf("day")
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      this.queryDate = queryDate;
      let pageNum = this.pageNum;

      this.getRevenueDetail({ queryDate, pageNum, type, deviceType: "lite" });
    },
    methods: {
      ...mapActions(["getRevenueDetail", "addDeviceNotes", "getDeviceWatchDetail", "getLastSevenRevenue"]),
      // 日期搜索
      search(queryDate) {
        this.queryDate = queryDate;
        let pageNum = this.pageNum;
        this.getRevenueDetail({ queryDate, pageNum, type,  deviceType: "lite" });
      },
      // mac搜索
      searchMac(mac_address) {
        let { selectDate, pageNum = 1 } = this;
        this.getRevenueDetail({
          pageNum,
          mac_address,
          queryDate: selectDate,
          type,
          deviceType: "lite"
        });
      },
      handleCurrentChange(value) {
        let defaultDate = moment()
          .utc()
          .startOf("day")
          .format("YYYY-MM-DD");
        let queryDate = this.selectDate || defaultDate;
        this.pageNum = value;
        this.getRevenueDetail({
          queryDate,
          pageNum: value,
          type,
          deviceType: "lite"
        });
      },
      // 添加备注
      addNote() {
        let that = this;
        this.addDeviceNotes({
          deviceId: this.addNoteId,
          note: this.addNoteInput
        }).then(res => {
          if (res.code === 200) {
            Message({
              type: "success",
              message: res.message
            });
            that.showAddnoteDialog = false;
            if (that.searchMacAddress === "all" || that.searchMacAddress === "") {
              this.getRevenueDetail({
                queryDate: that.selectDate,
                pageNum: that.pageNum,
                type,
                deviceType: "lite"
              });
            } else {
              this.getDeviceDetail({ id: that.searchMacAddress });
            }
          } else {
            Message({
              type: "error",
              message: res.message || "add note error"
            });
          }
        });
      },
      // 备注框
      showNotes(id, address) {
        this.showAddnoteDialog = true;
        this.addNoteId = id;
        this.addNoteAddress = address;
      },
      // 显示监控
      showWatchDetail(type, id) {
        let that = this;
        this.showWatchDialog = true;
        this.watchId = (type === 'id' ) ? id : this.watchId;
        let queryDate = this.searchWatchDate;

        let watchStable = this.$t("watchDetail.watchStable");
        let watchDate = this.$t("watchDetail.watchDate");
        let watchAvaliable = this.$t("watchDetail.watchAvaliable");
  
        this.getDeviceWatchDetail({
          id: this.watchId,
          queryDate
        }).then(res => {
          if (res && res.length) {
            // 此处为了中英文对照，所以动态处理
             let stableCharts = {
              columns: [],
              rows: []
            }, availabilityChart = {
              columns: [],
              rows: []
            };

            let stableColumns = [], availabilityColumns = [];
            stableColumns.push(watchDate);
            stableColumns.push(watchStable);
            stableCharts.columns = stableColumns;

            availabilityColumns.push(watchDate);
            availabilityColumns.push(watchAvaliable);
            availabilityChart.columns = availabilityColumns;

            res.map(item => {
              let { time, stable, ext_storage_size, tx_bandwidth } = item;
              let date_at = moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");

              let stableRows = [], availabilityRows = [];
              // 日期处理
              stableRows[watchDate] = date_at,
                availabilityRows[watchDate] = date_at;

              stableRows[watchStable] = stable;
              availabilityRows[watchAvaliable] = (stable < 2500 && stable > 0) ? 100 : 0;
              stableCharts.rows.push(stableRows);
              availabilityChart.rows.push(availabilityRows);
            });

            that.stableCharts =  stableCharts;
            that.availabilityChart =  availabilityChart;
            that.showCharts = true;
          } else {
            that.showCharts = false;
          }
        });
      },
      showDeviceRevenue(deviceId) {
        this.getLastSevenRevenue({deviceId}).then(res => {
          this.showLastRevenueDialog = true;
          // this.selectedDeviceId = deviceId;
          if (res && res.data) {
            let data = res.data;
            let chartData = {
              columns: ['日期', '当日网络总收益预估（BP）'],
              rows: []
            };
            for (let i in data) {
              let item = data[i];
              chartData.rows.push({
                '日期': moment(Number(i)).format('YYYY MM DD'),
                '当日网络总收益预估（BP）': item.network_bxc,
              })
            }
  
            this.chartData = chartData;

          }
        });
      }
    }
  };
</script>

<style lang="stylus">
  .data-panel-wrap,
  .data-panel-layout,
  .home {
    height: 100%;
  }

  .revenue-all-layout {
    height: 100%;
  }

  .revenue-date-wrap {
    margin: 0 20px;
  }

  .revenue-detail-select {
    text-align: left;
    padding-bottom: 30px;
    margin-bottom: 30px;
    border-bottom: 1px solid #ddd;
  }

  .revenue-tips {
    display: inline-block;
    margin: 0 20px;
    color: #96999b;
  }

  .add-note-button {
    max-width: 80px;
  }

</style>

<i18n>
  {
  "zn": {
  "revenueDate": "查询日期（UTC）",
  "revenueMac": "查询MAC地址",
  "mac_address": "设备",
  "device_revenue": "设备收益",
  "noteText": "备注",
  "search_mac_address": "搜索Mac地址",
  "noteText": "备注",
  "allSearch": "全部",
  "tolal_revenue": "当日网络总收益预估",
  "tx_bw": "节点网络质量"
  },
  "en": {
  "revenueDate": "Date（UTC）",
  "revenueMac": "Mac Address",
  "mac_address": "Mac Address",
  "device_revenue": "device revenue",
  "search_mac_address": "Mac Address",
  "noteText": "note",
  "allSearch": "All",
  "tolal_revenue": "Total Network Revenue:",
  "tx_bw": "Node Stability"
  }
  }
</i18n>
